module.exports = __webpack_public_path__ + "img/deni.02dcce2a.png";